var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('master-table',{attrs:{"top-title":"Master Referensi","title":"Provinsi","items":_vm.items,"fields":_vm.fields,"clickable-rows":true,"is-add-button":false},on:{"clicked-row":_vm.showDetailProvinsi}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }